__turbopack_context__.v({
  "buttonHomeWrapper": "ButtonHome-module-scss-module__k8yIpG__buttonHomeWrapper",
});
